import { gql } from "@apollo/client";

export default gql`
  query Product($id: Int!) {
    product(id: $id) {
      id
      siscomexLastSyncType
      lastSyncErrorMessage
      siscomexProduct {
        id
        ncmCode
        description
        lastUpdatedAt
        insertedAt
      }
      additionalDetails
      c9Ratio
      category
      code
      contentCapacity
      contentCode
      contentMeasurementUnit
      contentPerPallet
      contentType
      cubagePerPackage
      description
      dumping
      family
      grossWeightPerPackage
      manufacturer
      mercosulCode
      multipleCode
      multiplePackageCapacity
      multiplePackageMeasurementUnit
      multiplePackagePerContainerFt20
      multiplePackagePerContainerFt40
      multiplePackagePerPallet
      multiplePackageType
      netWeightPerPackage
      packageCapacity
      packageCode
      packageMeasurementUnit
      packagesPerContainerFt20
      packagesPerContainerFt40
      packagesPerPallet
      packageType
      palletsPerContainerFt20
      palletsPerContainerFt40
      translatedDescription
      translatedDescriptions
      hasContainerization
      hasContent
      hasPalletization
      hasUnitization
      actor {
        id
        rootCnpjs
      }
      country {
        code
        iso3
      }
      internalCodes {
        id
        code
        label
      }
      productForeignOperators {
        id
        nickname
        officialName
        officialDocument
        openingDate
        partnershipAsPartner {
          id
          nicknameWithFallback
        }
      }
    }
  }
`;
